import { parentWithLinks } from './parentWithLinks';
import { parentWithNoLinks } from './parentWithNoLinks';

export default {
  parentWithLinks,
  parentWithNoLinks
};
